import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params = null, callbackFinally) => {
    return AppModel.get(
      'spec/search_focus_plan',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        let modelStore = store.getters.model
        if (!modelStore) {
          modelStore = {}
        }

        modelStore['specSearchFocusPlan'] = res.data
        store.commit('setModel', modelStore)

        return Promise.resolve(res.data)
      },
      null, callbackFinally
    )
  },
  getStore: (key) => {
    return AppModel.getStore('specSearchFocusPlan', key)
  },
  removeStore: () => {
    delete store.getters.model.agenda
  }
}



// WEBPACK FOOTER //
// ./src/models/SearchSpecFocusPlanModel.js